import {Name} from './Name';
import {Price} from './Price';
import {Input} from './Input';
import {Header} from './Header';
import {Rating} from './Rating';
import {Footer} from './Footer';
import {FooterWrapper} from './FooterWrapper';
import {Button} from './Button';
import {Loader} from './Loader';
import {Switch} from './Switch';
import {RatingStars} from './RatingStars';
import {BlockHeading} from './BlockHeading';
import {Modal}   from './Modal'

import {AnimatedOrderList} from './AnimatedOrderList';

export const components = {
  Name,
  Header,
  Button,
  Input,
  Footer,
  FooterWrapper,
  Price,
  Loader,
  Rating,
  Switch,
  RatingStars,
  BlockHeading,
  Modal,
  AnimatedOrderList,
};
